import React, { useContext } from 'react';
import { FlagContext } from './FlagContext';
import { isFlagEnabled } from './helpers';

const withFeatureBranch =
  <TProps extends object>(featureToComponentMap: { [k: string]: React.ComponentType<TProps> }) =>
  (Component: React.ComponentType<TProps>) => {
    const DecoratedFC = React.forwardRef<HTMLElement, TProps>((props, ref) => {
      const flags = useContext(FlagContext);
      const enabled = Object.keys(featureToComponentMap)
        .filter(feature => isFlagEnabled(flags, feature))
        .map(feature => featureToComponentMap[feature]);

      // use the first one
      const FeatureComponent: any = enabled.length ? enabled[0] : Component;
      return <FeatureComponent ref={ref} {...props} />;
    });
    DecoratedFC.displayName = `withFeatureBranch(${Component.displayName || 'Component'})`;

    return DecoratedFC as React.FC<TProps>;
  };

export default withFeatureBranch;
